var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKids(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.889,
    height: 12.599,
    viewBox: "0 0 13.889 12.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "baby-boy",
    d: "M13.547,29.958a1.162,1.162,0,0,0-.8-.341l-.305-.006-.08-.295a5.613,5.613,0,0,0-3.354-3.747,2.364,2.364,0,1,1-4.425,1.157h.813a1.551,1.551,0,1,0,1.551-1.551q-.119,0-.236,0H6.635a1.388,1.388,0,0,1-1.383-1.387H4.439a2.19,2.19,0,0,0,.494,1.387H4.539a1.389,1.389,0,0,1-1.387-1.387H2.338A2.2,2.2,0,0,0,4.1,25.951,5.6,5.6,0,0,0,1.53,29.316l-.08.295-.305.006a1.168,1.168,0,0,0,0,2.336l.305.006.08.295a5.61,5.61,0,0,0,10.829,0l.08-.295.305-.006a1.174,1.174,0,0,0,1.145-1.168,1.162,1.162,0,0,0-.342-.827Zm-9.228.366a.644.644,0,0,0-.644.644H2.862a1.457,1.457,0,1,1,2.914,0H4.963A.644.644,0,0,0,4.319,30.324Zm2.625,4.185a2.519,2.519,0,0,1-2.16-1.235l.7-.413a1.693,1.693,0,0,0,2.919,0l.7.413A2.519,2.519,0,0,1,6.945,34.509Zm3.269-3.542a.644.644,0,1,0-1.287,0H8.113a1.457,1.457,0,1,1,2.914,0Z",
    transform: "translate(0 -23.794)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/kids.e0ae0ac0e0e4a26849c8fce40c3cbfdd.svg";
export { ForwardRef as ReactComponent };